import { cn } from '@/utils'

const BlurHeader = ({ className }: { className?: string }) => {
  return (
    <div className={cn('absolute inset-0 h-[80px] overflow-hidden', className)}>
      <div className="mask-blur absolute inset-0 filter backdrop-blur-[1px]" />
      <div className="mask-blur absolute inset-0 filter backdrop-blur-[2px]" />
      <div className="mask-blur absolute inset-0 filter backdrop-blur-[3px]" />
      <div className="mask-blur absolute inset-0 filter backdrop-blur-[6px]" />
      <div className="mask-blur absolute inset-0 filter backdrop-blur-[12px]" />
      <div className="gradient-transparent absolute inset-0" />
    </div>
  )
}

export default BlurHeader
